import {
  createItemRequest,
  fetchItemRequest,
  updateItemRequest,
  fetchItemsRequest,
  deleteItemRequest
} from "../api/index";
import { handleErrorRequest } from "../helpers/api";
import _ from "lodash";
import { createSelector } from "reselect";

const getItems = state => _.get(state, "items.items", []);
export const getRequiredItems = createSelector(
  getItems,
  items => items.filter(({ required }) => required)
);
export const getConfirmedItems = createSelector(
  getItems,
  items =>
    items
      .filter(({ confirmed }) => confirmed)
      .map(item => ({ ...item, stage: "confirmed" }))
);
export const getCompletedItems = createSelector(
  getItems,
  items =>
    items
      .filter(({ completed }) => completed)
      .map(item => ({ ...item, stage: "completed" }))
);
export const getRecommendedItems = createSelector(
  getItems,
  items => items.filter(({ required }) => !required)
);

export const CREATE_ITEM_ATTEMPT = "items/CREATE_ITEM_ATTEMPT";
export const CREATE_ITEM_SUCCESS = "items/CREATE_ITEM_SUCCESS";
export const CREATE_ITEM_FAILURE = "items/CREATE_ITEM_FAILURE";

export const UPDATE_ITEM_ATTEMPT = "items/UPDATE_ITEM_ATTEMPT";
export const UPDATE_ITEM_SUCCESS = "items/UPDATE_ITEM_SUCCESS";
export const UPDATE_ITEM_FAILURE = "items/UPDATE_ITEM_FAILURE";

export const DELETE_ITEM_ATTEMPT = "items/DELETE_ITEM_ATTEMPT";
export const DELETE_ITEM_SUCCESS = "items/DELETE_ITEM_SUCCESS";
export const DELETE_ITEM_FAILURE = "items/DELETE_ITEM_FAILURE";

export const FETCH_ITEM_ATTEMPT = "items/FETCH_ITEM_ATTEMPT";
export const FETCH_ITEM_SUCCESS = "items/FETCH_ITEM_SUCCESS";
export const FETCH_ITEM_FAILURE = "items/FETCH_ITEM_FAILURE";

export const FETCH_ITEMS_ATTEMPT = "items/FETCH_ITEMS_ATTEMPT";
export const FETCH_ITEMS_SUCCESS = "items/FETCH_ITEMS_SUCCESS";
export const FETCH_ITEMS_FAILURE = "items/FETCH_ITEMS_FAILURE";

export const SET_CURRENT_ITEM = "items/SET_CURRENT_ITEM";
export const SET_ITEMS = "items/SET_ITEMS";
export const SET_SHOW_ITEMS = "items/SET_SHOW_ITEMS";

export const RESET_STATE = "items/RESET_STATE";

const createItemAttempt = () => ({ type: CREATE_ITEM_ATTEMPT });
const createItemSuccess = () => ({ type: CREATE_ITEM_SUCCESS });
const createItemFailure = failMessage => ({
  type: CREATE_ITEM_FAILURE,
  failMessage
});

const updateItemAttempt = () => ({ type: UPDATE_ITEM_ATTEMPT });
const updateItemSuccess = () => ({ type: UPDATE_ITEM_SUCCESS });
const updateItemFailure = failMessage => ({
  type: UPDATE_ITEM_FAILURE,
  failMessage
});

const deleteItemAttempt = () => ({ type: DELETE_ITEM_ATTEMPT });
const deleteItemSuccess = () => ({ type: DELETE_ITEM_SUCCESS });
const deleteItemFailure = failMessage => ({
  type: DELETE_ITEM_FAILURE,
  failMessage
});

const fetchItemAttempt = () => ({ type: FETCH_ITEM_ATTEMPT });
const fetchItemSuccess = () => ({ type: FETCH_ITEM_SUCCESS });
const fetchItemFailure = failMessage => ({
  type: FETCH_ITEM_FAILURE,
  failMessage
});

const fetchItemsAttempt = () => ({ type: FETCH_ITEMS_ATTEMPT });
const fetchItemsSuccess = () => ({ type: FETCH_ITEMS_SUCCESS });
const fetchItemsFailure = failMessage => ({
  type: FETCH_ITEMS_FAILURE,
  failMessage
});

const setCurrentItem = currentItem => ({ type: SET_CURRENT_ITEM, currentItem });

const setItems = items => ({ type: SET_ITEMS, items });

const setShowItems = itemType => ({ type: SET_SHOW_ITEMS, itemType });

const createItemAsync = ({ dealer_id, contract_id, data }) => (
  dispatch,
  getState
) => {
  dispatch(createItemAttempt());
  let jwt = _.get(getState(), "auth.user.jwt", "");
  return createItemRequest({
    data: { item: data },
    dealer_id,
    contract_id,
    jwt
  }).then(({ response, error }) => {
    if (response) {
      dispatch(createItemSuccess());
      const item = response.data;
      dispatch(createItemSync(item.id, item));
      return Promise.resolve(item);
    } else {
      dispatch(createItemFailure(handleErrorRequest(error)));
      return Promise.reject(error);
    }
  });
};

const createItemSync = (id, item) => (dispatch, getState) => {
  const items = getState().items.items || [];
  const itemCopy = Object.assign({}, { id }, item);
  dispatch(setItems([...items, itemCopy]));
};

const fetchItem = ({ dealer_id, item_id, contract_id }) => (
  dispatch,
  getState
) => {
  dispatch(fetchItemAttempt());
  let jwt = _.get(getState(), "auth.user.jwt", "");
  return fetchItemRequest({ item_id, dealer_id, contract_id, jwt }).then(
    ({ response, error }) => {
      if (response) {
        dispatch(fetchItemSuccess());
        dispatch(setCurrentItem(response.data));
        return Promise.resolve(response.data);
      } else {
        dispatch(fetchItemFailure(handleErrorRequest(error)));
        return Promise.reject(error);
      }
    }
  );
};

const fetchItems = ({ dealer_id, contract_id }) => (dispatch, getState) => {
  dispatch(fetchItemsAttempt());
  let jwt = _.get(getState(), "auth.user.jwt", "");
  return fetchItemsRequest({ dealer_id, contract_id, jwt }).then(
    ({ response, error }) => {
      if (response) {
        dispatch(fetchItemsSuccess());
        dispatch(setItems(response.data));
        return Promise.resolve(response.data);
      } else {
        dispatch(fetchItemsFailure(handleErrorRequest(error)));
        return Promise.reject(error);
      }
    }
  );
};

const updateItemAsync = ({ dealer_id, contract_id, item_id, data }) => (
  dispatch,
  getState
) => {
  dispatch(updateItemAttempt());
  let jwt = _.get(getState(), "auth.user.jwt", "");
  return updateItemRequest({
    dealer_id,
    item_id,
    contract_id,
    data: { item: data },
    jwt
  }).then(({ response, error }) => {
    if (response) {
      dispatch(updateItemSuccess());
      dispatch(updateItemSync(response.data));
      return Promise.resolve(response.data);
    } else {
      dispatch(updateItemFailure(handleErrorRequest(error)));
      return Promise.reject(error);
    }
  });
};

const updateItemSync = item => (dispatch, getState) => {
  const currentItem = getState().items.currentItem || { id: item.id };
  const items = [...getState().items.items];
  var index = _.findIndex(items, { id: currentItem.id });
  if (index !== -1) {
    items.splice(index, 1, Object.assign({}, currentItem, item));
    dispatch(setItems([...items]));
  }
  dispatch(setCurrentItem(null));
};

const deleteItemAsync = ({ dealer_id, contract_id, item_id }) => (
  dispatch,
  getState
) => {
  dispatch(deleteItemAttempt());
  let jwt = _.get(getState(), "auth.user.jwt", "");
  return deleteItemRequest({ dealer_id, item_id, contract_id, jwt }).then(
    ({ response, error }) => {
      if (response) {
        dispatch(deleteItemSuccess());
        dispatch(deleteItemSync(item_id));
      } else {
        dispatch(deleteItemFailure(handleErrorRequest(error)));
      }
    }
  );
};

const deleteItemSync = item_id => (dispatch, getState) => {
  const items = getState().items.items || [];
  const currentItem = getState().items.currentItem || {};
  let nextItems = _.reject(items, { id: item_id });
  dispatch(setItems(nextItems));
  item_id === currentItem.id && dispatch(setCurrentItem(null));
};

const resetState = () => ({ type: RESET_STATE });

export const actions = {
  createItemAsync,
  createItemSync,
  fetchItem,
  fetchItems,
  setItems,
  setShowItems,
  updateItemAsync,
  updateItemSync,
  deleteItemAsync,
  deleteItemSync,
  setCurrentItem,
  resetState,
  createItemAttempt,
  createItemSuccess,
  createItemFailure,
  updateItemAttempt,
  updateItemSuccess,
  updateItemFailure,
  deleteItemAttempt,
  deleteItemSuccess,
  deleteItemFailure,
  fetchItemAttempt,
  fetchItemSuccess,
  fetchItemFailure,
  fetchItemsAttempt,
  fetchItemsSuccess,
  fetchItemsFailure
};

const ITEM_ACTION_HANDLERS = {
  [CREATE_ITEM_ATTEMPT]: (state, action) => ({
    ...state,
    submittingItem: true,
    failSubmitItem: null,
    successSubmitItem: false
  }),
  [CREATE_ITEM_SUCCESS]: (state, action) => ({
    ...state,
    submittingItem: false,
    failSubmitItem: null,
    successSubmitItem: true
  }),
  [CREATE_ITEM_FAILURE]: (state, action) => ({
    ...state,
    submittingItem: false,
    failSubmitItem: action.failMessage,
    successSubmitItem: false
  }),
  [UPDATE_ITEM_ATTEMPT]: (state, action) => ({
    ...state,
    submittingItem: true,
    failSubmitItem: null,
    successSubmitItem: false
  }),
  [UPDATE_ITEM_SUCCESS]: (state, action) => ({
    ...state,
    submittingItem: false,
    failSubmitItem: null,
    successSubmitItem: true
  }),
  [UPDATE_ITEM_FAILURE]: (state, action) => ({
    ...state,
    submittingItem: false,
    failSubmitItem: action.failMessage,
    successSubmitItem: false
  }),
  [DELETE_ITEM_ATTEMPT]: (state, action) => ({
    ...state,
    submittingItem: true,
    failSubmitItem: null,
    successSubmitItem: false
  }),
  [DELETE_ITEM_SUCCESS]: (state, action) => ({
    ...state,
    submittingItem: false,
    failSubmitItem: null,
    successSubmitItem: true
  }),
  [DELETE_ITEM_FAILURE]: (state, action) => ({
    ...state,
    submittingItem: false,
    failSubmitItem: action.failMessage,
    successSubmitItem: false
  }),
  [FETCH_ITEM_ATTEMPT]: (state, action) => ({
    ...state,
    fetchingItem: true,
    failFetchItem: null,
    successFetchItem: false
  }),
  [FETCH_ITEM_SUCCESS]: (state, action) => ({
    ...state,
    fetchingItem: false,
    failFetchItem: null,
    successFetchItem: true
  }),
  [FETCH_ITEM_FAILURE]: (state, action) => ({
    ...state,
    fetchingItem: false,
    failFetchItem: action.failMessage,
    successFetchItem: false
  }),
  [FETCH_ITEMS_ATTEMPT]: (state, action) => ({
    ...state,
    fetchingItems: true,
    failFetchItems: null,
    successFetchItems: false
  }),
  [FETCH_ITEMS_SUCCESS]: (state, action) => ({
    ...state,
    fetchingItems: false,
    failFetchItems: null,
    successFetchItems: true
  }),
  [FETCH_ITEMS_FAILURE]: (state, action) => ({
    ...state,
    fetchingItems: false,
    failFetchItems: action.failMessage,
    successFetchItems: false
  }),
  [SET_CURRENT_ITEM]: (state, action) => ({
    ...state,
    currentItem: action.currentItem
  }),
  [SET_ITEMS]: (state, action) => ({ ...state, items: action.items }),
  [SET_SHOW_ITEMS]: (state, action) => ({
    ...state,
    showItems: action.itemType
  }),
  [RESET_STATE]: (state, action) => ({
    ...state,
    ...initialState,
    ...{ items: state.items, currentItem: state.currentItem }
  })
};

export const initialState = {
  submittingItem: false,
  failSubmitItem: null,
  successSubmitItem: false,
  fetchingItem: false,
  failFetchItem: null,
  successFetchItem: false,
  currentItem: null,
  fetchingItems: false,
  failFetchItems: null,
  successFetchItems: false,
  showItems: "all",
  items: []
};

export default function itemReducer(state = initialState, action) {
  const handler = ITEM_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
